export default {
  //hostname: "http://localhost:5002",
  //hostname: "https://api.examination-system.online",
  hostname: "https://examapi.lci-coaching.com",
};
